<template>
  <article class="layout-section -bg-primary">
    <div class="layout-section__hgroup">
      <h2 class="layout-section__title -no-space">{{ section.title }}</h2>
      <p v-if="section.subtitle">{{ section.subtitle }}</p>
    </div>

    <section class="layout-grid">
      <div v-for="entry in section.partners" :key="entry.text" class="layout-grid__item card">
        <div class="card__logo" :class="{ '-bigger': entry.isNarrow }">
          <img :src="entry.logo" :alt="entry.text" />
          <div class="card__legend">{{ entry.text }}</div>
        </div>
      </div>
    </section>
  </article>
</template>

<script>
export default {
  name: 'PartnersIndex',
  props: {
    section: {
      type: Object,
      required: true
    }
  }
}
</script>
